import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Dialog, Link } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import "./AuditStatusUpdate.scss";
import TextArea from "antd/es/input/TextArea";
import { DatePicker, DatePickerProps, Input } from "antd";
import { updateExternalAuditService } from "../../services/verificationService";
const AuditStatusUpdate = (props: any) => {
  const {
    setOpenUpdate,
    openUpdate,
    updateStatusFormData,
    setUpdateStatusFormData,
    eachAuditData,
    statusUpdateSelectedIndex,
    toStatus,
    setToStatus,
    setExternalAuditsList,
    externalAuditsList,
    statusUpdateSelectedListIndex,
    setEachAuditData,
    fromDetailedView,
  } = props;

  const handleStatusUpdate = () => {
    setOpenUpdate(false);
    let selectedToStatus: any;
    if (toStatus === "Deactivate") {
      selectedToStatus = "Deactivated";
      setToStatus(selectedToStatus);
    }
    updateExternalAuditService({
      ...updateStatusFormData,
      status: selectedToStatus,
      id: statusUpdateSelectedIndex,
    })
      .then((res: any) => {
        setUpdateStatusFormData({
          status: "",
          comments: "",
        });
        if (fromDetailedView) {
          const eachAudit = eachAuditData;
          eachAudit.status = selectedToStatus;
          setEachAuditData(eachAudit);
        }
        const prevAuditList = externalAuditsList;
        prevAuditList[statusUpdateSelectedListIndex].status = selectedToStatus;
        setExternalAuditsList(prevAuditList);

        setOpenUpdate(false);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  const handleClose = () => {
    setUpdateStatusFormData({
      comments: "",
      status: "",
    });
    setOpenUpdate(false);
  };

  return (
    <Fragment>
      <div className="pw-file-attachement-container">
        <Dialog className="pw-dialog-container-test" open={openUpdate}>
          <div className="pw-dialog-container">
            <div className="flex justify-between items-center w-full">
              <div className="pw-header-text">Update status</div>
              <div className="cursor-pointer">
                <CloseIcon
                  className="pw-color-close-attchments"
                  onClick={handleClose}
                />
              </div>
            </div>

            <div className="flex justify-between items-center w-full mt-1">
              <div className="pw-color-neutral-900 text-sm">
                Are you sure you want to update the status from
                <span
                  className={`font-bold pw-${eachAuditData?.status.toLowerCase()}`}
                >
                  {" "}
                  {eachAuditData?.status}
                </span>{" "}
                to{" "}
                <span className={`font-bold pw-${toStatus.toLowerCase()}`}>
                  {" "}
                  {toStatus}
                </span>{" "}
              </div>
            </div>

            <div className="w-full mt-4">
              <div className="pw-color-neutral-600 text-sm">Add Comments</div>
              <TextArea
                value={updateStatusFormData?.comments}
                onChange={(e) =>
                  setUpdateStatusFormData({
                    ...updateStatusFormData,
                    comments: e.target.value,
                  })
                }
                placeholder="Comments"
                className="w-full pw-comments-field mt-1 p-4"
              />
              <div className="flex justify-end pw-color-neutral-400">0/100</div>
            </div>
          </div>
          <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6">
            <div
              className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
              onClick={handleClose}
            >
              Cancel
            </div>
            <button
              className={
                "pw-bunit-button-primary pw-bunit-button-next text-white font-bold cursor-pointer bg-primary"
              }
              onClick={handleStatusUpdate}
            >
              Save
            </button>
          </div>
        </Dialog>
      </div>
    </Fragment>
  );
};

export default AuditStatusUpdate;
